// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Ax3FT","text":"SelectPayment_text__1MuTr","title":"SelectPayment_title__3ijEx","btn":"SelectPayment_btn__3kcQu"};